import { DOCUMENT_MODE } from "../../../constants/document";
import DeletePDFDocCommand from "../deleteComponentCommandBase/deletePDFDocCommand";
import DeletePDFTemplateCommand from "../deleteComponentCommandBase/deletePDFTemplateCommand";
import DummyCommand from "../dummyCommand";
import DeleteSignatureDocCommand from "./deleteSignatureDocCommand";
import DeleteSignatureTemplateCommand from "./deleteSignatureTemplateCommand";

class DeleteSignatureFactory {
  static getCommand(mode, isPDF, componentData) {
    if (isPDF && mode === DOCUMENT_MODE.DOCUMENT) {
      return new DeletePDFDocCommand(componentData);
    }
    if (isPDF && mode === DOCUMENT_MODE.TEMPLATE) {
      return new DeletePDFTemplateCommand(componentData);
    }
    if (mode === DOCUMENT_MODE.DOCUMENT) {
      return new DeleteSignatureDocCommand(componentData);
    }
    if (mode === DOCUMENT_MODE.TEMPLATE) {
      return new DeleteSignatureTemplateCommand(componentData);
    }
    return new DummyCommand();
  }
}

export default DeleteSignatureFactory;
